/**
 * 発注関連ロジック
 */
class SubmitOrder
{
    /**
     * 現在申込みが可能な年度のリストを返す
     *
     * 2月までは今年度
     * 3月からは次年度
     *
     * @return int[]
     */
    static orderableYears()
    {
        const today = new Date();

        if ((today.getMonth() + 1) === 3) {
            if (today.getDate() <= 15) {
                // 今年度・来年度
                return [
                    (today.getFullYear() - 1),
                    today.getFullYear(),
                ];

            } else {
                // 来年度
                return [
                    today.getFullYear(),
                ];
            }

        } else if ((today.getMonth() + 1) === 1 || (today.getMonth() + 1) === 2) {
            return [
                 // 今年度
                (today.getFullYear() - 1)
            ];

        } else {
            return [
                 // 今年度
                today.getFullYear()
            ];
        }
    }
}

export default SubmitOrder;